import React, {Component} from 'react';
import {connect} from 'react-redux'
import {fetchOrder} from '../../../redux/ActionCreaters'
import SingleOrder from './SingleOrder';
import Spinner from '../../Spinner/Spinner'

const mapStateToProps = state => {
    return {
        orders: state.orders,
        orderLoading: state.orderLoading,
        orderErr: state.orderErr,
        userId:state.userId,
        token:state.token,
    }
}


const mapDispatchToProps=()=>dispatch=>{
    return{
        fetchOrder:(token,userId)=>dispatch(fetchOrder(token,userId))
    }
}
class Order extends Component{
    componentDidMount(){
        this.props.fetchOrder(this.props.token,this.props.userId);
    }
    render(){
        let order=this.props.orders.map(item=>{
            return <SingleOrder order={item} key={item.id} />
        })
        if(this.props.orderErr){
             return <div className="border">Find a error!</div>
        }
        else{
            if(this.props.orders.length===0){
                return <div className="border">You have no order!</div>
            }
            return(
                <div>
                    {this.props.orderLoading? <Spinner /> :order}
                </div>
            )
        }
        
    }
    
}
export default connect(mapStateToProps,mapDispatchToProps)(Order);